<template>
  <div class="container-fluid mt-2">
    <div class="row">
      <div class="card">
        <div class="card-header">
          {{ t.giro }}
        </div>
        <DateFilter :startDate="startDate" :endDate="endDate" v-on:data-change="updateDate"></DateFilter>
        <div class="card-block p-0">
          <div class="table-responsive" v-if="data">
            <table class="table mb-0">
              <thead>
              <tr>
                <th colspan="4" v-if="data">
                  <span class="tag tp tag-primary">{{ t.time_range }}</span> {{ startDate }} - {{ endDate }}<br>
                  <span class="tag tag-info" style="width:100px;text-align:left">{{ t.custom_reseller_panel.balance_in}}</span> {{ data.total.in | toMoney(session.currency) }}<br>
                  <span class="tag tag-danger" style="width:100px;text-align:left">{{ t.custom_reseller_panel.balance_out}}</span> {{ data.total.out | toMoney(session.currency) }}<br>
                  <span class="tag tag-success" style="width:100px;text-align:left">{{ t.giro }}</span> {{ (data.total.in - data.total.out) | toMoney(session.currency) }}</th>
              </tr>
              </thead>
            </table>
            <br><br>
            <div class="col-xs-6 col-sm-4 col-lg-3">
              <div class="card card-inverse card-success">
                <div class="card-block p-1">
                  <div>{{ t.custom_reseller_panel.cash }}</div>
                  <div class="h4 m-a-0">{{ (data.cash.in - data.cash.out) | toMoney(session.currency) }}</div>
                </div>
              </div>
            </div>
            <div class="col-xs-6 col-sm-4 col-lg-3">
              <div class="card card-inverse card-success">
                <div class="card-block p-1">
                  <div>Bank</div>
                  <div class="h4 m-a-0">{{ (data.bank.in - data.bank.out) | toMoney(session.currency) }}</div>
                </div>
              </div>
            </div>
            <div class="col-xs-6 col-sm-4 col-lg-3">
              <div class="card card-inverse card-success">
                <div class="card-block p-1">
                  <div>{{ t.custom_reseller_panel.open_account }}</div>
                  <div class="h4 m-a-0">{{ (data.open.in - data.open.out) | toMoney(session.currency) }}</div>
                </div>
              </div>
            </div>
            <div class="col-xs-6 col-sm-4 col-lg-3">
              <div class="card card-inverse card-success">
                <div class="card-block p-1">
                  <div>{{ t.custom_reseller_panel.credit }}</div>
                  <div class="h4 m-a-0">{{ (data.credit.in - data.credit.out) | toMoney(session.currency) }}</div>
                </div>
              </div>
            </div>
            <div class="col-xs-6 col-sm-4 col-lg-3">
              <div class="card card-inverse card-success">
                <div class="card-block p-1">
                  <div>{{ t.custom_reseller_panel.credit_card }}</div>
                  <div class="h4 m-a-0">{{ (data.credit_card.in - data.credit_card.out) | toMoney(session.currency) }}</div>
                </div>
              </div>
            </div>
            <div class="col-xs-6 col-sm-4 col-lg-3">
              <div class="card card-inverse card-success">
                <div class="card-block p-1">
                  <div>Bonus</div>
                  <div class="h4 m-a-0">{{ (data.bonus.in - data.bonus.out) | toMoney(session.currency) }}</div>
                </div>
              </div>
            </div>
            <div class="col-xs-6 col-sm-4 col-lg-3">
              <div class="card card-inverse card-success">
                <div class="card-block p-1">
                  <div>{{ t.selection.other }}</div>
                  <div class="h4 m-a-0">{{ (data.other.in - data.other.out) | toMoney(session.currency) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateFilter from "../DateFilter";
import Loading from "../Loading";
import AdminGiroRow from "../row/AdminGiroRow";
export default {
  name: "Daily",
  components: {Loading, DateFilter, AdminGiroRow},
  data() {
    return {
      session: window.session,
      startDate: moment().format("DD MMMM YYYY ddd"),
      endDate: moment().format("DD MMMM YYYY ddd"),
      data: null,
      loading: false,
      t: this.$root.t,
      totalBetProfit: 0,
      totalCasinoProfit: 0
    }
  },
  watch: {
    '$route.query.referrer' () {
      this.fetchCustomers();
    },
    'startDate' () {
      this.fetchCustomers()
    },
    'endDate' () {
      this.fetchCustomers()
    }
  },
  mounted() {
    setTimeout(() => {
      this.startDate = moment().format("YYYY-MM-DD");
      this.endDate = moment(new Date()).format("YYYY-MM-DD")
      this.fetchCustomers()
    }, 2000);
  },
  methods: {
    updateDate (e) {
      this.fetchCustomers();
    },
    fetchCustomers() {
      this.loading = true;
      this.$http.get(api + 'api/v1/reseller_daily', {
        params: {start: this.startDate, end: this.endDate}
      })
      .then(response => {
        this.data = response.body.result;
        this.loading = false;
      }, response => {
        this.loading = false;
        this.data = [];
      })
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/Daily.vue